// Workbench staging-area persistence + cross-tab broadcast.
// Why this exists: the Workbench component unmounts when the user switches to the
// Operations tab, losing any React-state staging. Persisting the staging text to
// sessionStorage (scoped per silo) lets the Output Recirculation Buffer append to
// staging while the user is on the Operations tab, and the Workbench will pick up
// the updated buffer the moment the user returns.
export const stagingStorageKey = (siloId) => `workbench_staging__${siloId || "noop"}`;

export const readStaging = (siloId) => {
  try { return sessionStorage.getItem(stagingStorageKey(siloId)) || ""; } catch { return ""; }
};

export const writeStaging = (siloId, text) => {
  try {
    sessionStorage.setItem(stagingStorageKey(siloId), text ?? "");
    // Let listeners on the same tab react — 'storage' events only fire across tabs.
    window.dispatchEvent(new CustomEvent("staging-updated", { detail: { siloId, length: (text || "").length } }));
  } catch { /* quota or private-mode — swallow */ }
};

export const appendToStaging = (siloId, text) => {
  if (!text) return { length: (readStaging(siloId) || "").length, appended: 0 };
  const current = readStaging(siloId);
  const merged = current ? `${current}\n\n${text}` : text;
  writeStaging(siloId, merged);
  return { length: merged.length, appended: text.length };
};
